// Chart7.js
import React from "react";

export const Chart7 = ({ data }) => {
  if (!data) return null;

  const { caption = "", columns = [], rows = [] } = data;

  return (
    <figure className="table">
      <table className="gdr">
        <caption style={{ captionSide: "top", textAlign: "center" }}>
          <p>{caption}</p>
        </caption>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th
                key={`col-${i}`}
                scope="col"
                style={{ textAlign: "center", verticalAlign: "bottom" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={`row-${i}`}>
              <th scope="row" style={{ textAlign: "left" }}>
                {row.designation}
              </th>
              <td style={{ textAlign: "center" }}>{row.mass}</td>
              <td style={{ textAlign: "center" }}>{row.radius}</td>
              <td style={{ textAlign: "center" }}>{row.orbitalPeriod}</td>
              <td style={{ textAlign: "center" }}>{row.distance}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
};

export default Chart7;
